import { render, staticRenderFns } from "./TheUserForm.vue?vue&type=template&id=4efdad86&scoped=true&lang=pug&"
import script from "./TheUserForm.vue?vue&type=script&lang=js&"
export * from "./TheUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efdad86",
  null
  
)

export default component.exports